/**
 * Created by Reda on 15.04.2026
 */

cleverapps.SkinManager.SKINS["undersea3_expedition"] = {
    bundle: "expedition_undersea3",

    slots: {
        workerSkin: function () {
            const json = cleverapps.skins.getSlot("worker_json") || bundles.mineable.jsons.worker_json;
            return cleverapps.Spine.hasSkin("undersea", json) ? "undersea" : undefined;
        },

        unitMoveAnimation: function () {
            return {
                json: bundles.merge.jsons.move_animation,
                zOrder: -1,
                sound: bundles.merge.urls.move_animation_effect
            };
        },

        gameAudio: function () {
            return bundles["expedition_undersea3"].urls.undersea_music;
        },

        bonusWorkerProductAnimation: function () {
            return cleverapps.config.name === "fairy" ? "animation" : "animation2";
        },

        bonusWorkerPersonSkin: function () {
            const animation = cleverapps.persons.getRole("narrator").json;
            return cleverapps.Spine.hasSkin("undersea", animation) ? "undersea" : undefined;
        },

        king: function () {
            return cleverapps.config.name === "fairy" ? "dwarf" : "king";
        },

        unitOnCell: function () {
            return cleverapps.styles.UnitOnCellExpedition;
        },

        gameSceneBg: function () {
            return {
                scale9: bundles["expedition_undersea3"].frames.undersea_bg,
                animation: bundles["expedition_undersea3"].jsons.undersea_bg_animation,
                topAnimation: bundles["expedition_undersea3"].jsons.undersea_bg_animation_top,
                parallax: true
            };
        },

        pixelViewType: function (type) {
            return cleverapps.styles.undersea3[type];
        },

        fogBlockWandPosition: function () {
            return cleverapps.config.name === "fairy" && cleverapps.styles.undersea3 && cleverapps.styles.undersea3.fogBlockWand;
        },

        merge_wand_png: bundles.menubar.frames.undersea3_merge_wand_png,

        wand_icon_png: bundles.buttons_inlined_icons_undersea3.frames.undersea3_wand_icon_png,
        feed_icon_png: bundles.buttons_inlined_icons_undersea3.frames.undersea3_feed_icon_png,

        expedition_buildpass_icon_json: bundles.sidebar.jsons.undersea_expedition_buildpass_icon_json,
        snail_feast_icon_json: bundles.sidebar.jsons.undersea_snail_feast_icon_json,
        snailhouse_offer_json: bundles.sidebar.jsons.undersea_snailhouse_offer_json,
        snailhouse_offer_extrabar_icon: bundles.extrabar && bundles.extrabar.jsons.undersea3_snailhouse_offer_extrabar_icon,
        pass_star_png: bundles.reward_icons_pass.frames.undersea3_pass_star_png,

        merge_animation_json: bundles.merge_animations.jsons.undersea3_merge_animation_json,

        snail_feast_icon: bundles.reward_icons_merge_undersea3.frames.undersea_snail_feast_icon,
        reward_wand_png: bundles.reward_icons_merge_undersea3.frames.undersea_reward_wand_png,
        reward_wand_small_png: bundles.reward_icons_merge_undersea3.frames.undersea_reward_wand_small_png,

        getPoiAnimation: function (unit) {
            if (unit.code === "rpcustomermain3a") {
                return "idle_fog";
            }
        },

        fog_disappear_effect: function () {
            return bundles.fog_undersea3.urls.open_effect;
        },

        getPerson: function () {
            return "_undersea";
        }
    }
};